interface OpportunityItemContent {
    applicationWindow: string;
    duration: string;
    organization: string;
    pageHeading: string;
    shortDescription: string;
    eligibleRole: string;
    competencies: string;
    contentLink: string;
    applyColor: string;
}
interface PaginationCenteredPages {
    isActive: boolean;
    isEllipsis: boolean;
    isLeftMost: boolean;
    isRightMost: boolean;
    pageNumber: number;
}

interface PagePagination {
    currentPageIndex: number;
    numberOfPageButtons: number;
    totalPages: number;
    centeredPages: PaginationCenteredPages[]
}

interface OpportunityFiltrations {
    termDisplayName: string;
    termGroup: string;
    termItemList: Array<{
        itemsCount: number;
        termId: string;
        termName: string;
        termValue: string;
    }>
}

interface OpportunityListResponce {
    pageSize: number;
    totalCount: number;
    totalPages: number;
    pagePagination: PagePagination;
    contentItems: OpportunityItemContent[];
    filtrations: Array<OpportunityFiltrations>
}
interface FilterTerm {
    filterId: string;
    terms: Array<{id: string; value: string;}>
}
interface FilterList {
    pageIndex: number;
    searchText: string;
    sort: string;
    terms: Array<FilterTerm>
}
export class OppotrunityList {
    pageId;
    pageElement: HTMLElement;
    opportunitiesListContainer;
    opportunitiesListData: OpportunityListResponce;
    newPageNunber: number;
    filter: FilterList = {
        pageIndex: 1,
        searchText: '',
        sort: '',
        terms: [],
    }
    constructor(page: HTMLElement, pageId: string | number) {
        this.pageElement = page;
        this.pageId = pageId;
    }

    init() {
        this.setDefaultilters();
        this.openFilterSelect(this.filter);
        this.searchEventListener();
        this.sortItemsEventListener();
        this.filterEventEmitter();
        // get oportunities list 
        this.getOpportunitiesList();
        
    }
    setDataToLS() {
        localStorage.setItem('opportunity-list-filters', JSON.stringify(this.filter))
    }

    openFilterSelect(filters: FilterList) {
        if (filters.terms.length) {
            filters.terms.forEach(term => {
                const el = document.querySelector(`button[aria-controls="${term.filterId}"]`)
                if (el && el.getAttribute('aria-expanded') === `false`) {
                    (el as HTMLElement).click()                    
                }
               
            })
        }
    }
    /* -------- Url Filters -------- */
    setFiltersToUrl(filters: FilterList) {
        const searchParams = new URLSearchParams(window.location.search);
        searchParams.set('pageIndex', JSON.stringify(filters.pageIndex));
        searchParams.set('sort', filters.sort);

        filters.searchText
            ? searchParams.set('searchText', filters.searchText)
            : searchParams.has('searchText') && searchParams.delete('searchText') // delete

        filters.terms.length
           ? searchParams.set('terms', this.convertFilterTermsToString(filters.terms))
           : searchParams.has('terms') && searchParams.delete('terms') // delete
 
        // Build the new URL and update the history.
        const newRelativePathQuery = window.location.pathname + '?' + searchParams.toString();
        history.pushState(null, '', newRelativePathQuery);
    }
    getFiltersFromUrl() {
        const queryString = window.location.search;
        
        if (queryString) {
            const urlParams = new URLSearchParams(queryString);
            urlParams.has('pageIndex') && (this.filter.pageIndex = Number(urlParams.get('pageIndex')));
            urlParams.has('sort') && (this.filter.sort = urlParams.get('sort'));
            urlParams.has('searchText') && (this.filter.searchText = urlParams.get('searchText'));
            urlParams.has('terms') && (this.filter.terms = this.convertStringToFilterTerms(urlParams.get('terms')));
            this.setDataToFilters(this.filter);
        }
    }

    /* -------- Set Filters from LocalStorage -------- */
    setDataToFilters(filter: FilterList) {
        // set Filters data
        if (filter.terms.length) {
            this.filter.terms.forEach(item => {
                item.terms.forEach(filterEl => {
                    const element = document.getElementById(filterEl.id);
                    (element as HTMLInputElement).checked = true;
                })
            })
        }

        //set sort
        if (filter.sort) {
            const sortElement = document.getElementById('opportunityItemSort');
            if (sortElement) {
                sortElement['value'] = filter.sort
            }
        }

        // Search
        if (filter.searchText) {
            const searchElement = document.getElementById('opportunitySearchInput');
            if (searchElement) {
                searchElement['value'] = filter.searchText;
                const inputClearBtn = document.querySelector('.opportunity-term-clear');
                if (inputClearBtn) {
                    inputClearBtn.classList.remove('visually-hidden')
                }
            }
        }
    }

    setDefaultilters() {
        const isFromDetailPage = localStorage.getItem('fromOpportunityDetailPage')
        if (isFromDetailPage) {
            const filtersData = localStorage.getItem('opportunity-list-filters')
            if (filtersData) {
                this.filter = JSON.parse(filtersData);
                this.setFiltersToUrl(this.filter)
                this.setDataToFilters(this.filter)
            }
        } else {
            if (window.location.search) {
                this.getFiltersFromUrl()
            } else {
                const filterEl = document.querySelectorAll('[name="opportunityCategory"]');
                if (filterEl && filterEl.length) {
                    setTimeout(() => { filterEl.forEach((filter: HTMLInputElement) => filter.checked = false) }, 200);
                }
            }
        }
    }

    updateFilterMarkers(filtration: Array<OpportunityFiltrations>): void {
        filtration.forEach(group => {
            const filterGroup = document.getElementById(group.termGroup);
            if (filterGroup) {
                group.termItemList.forEach(term => {
                    const label = filterGroup.querySelector(`label[for="${term.termId}"]`)
                    if (label) {
                        label.querySelector('span').innerHTML = ` (${term.itemsCount})`;
                    }
                })
            }
            
        })
    }
    /* -------- Filter Logic ----------- */
    resetFiltersEventListener(filtersInputs) {
        const resetBtn = document.getElementById('resetOpportunitiesCategories')
        if (resetBtn) {
            resetBtn.addEventListener('click', () => {
                this.filter.terms = [];
                (filtersInputs as HTMLInputElement[]).forEach(filter => filter.checked = false);
                this.setDataToLS();
                this.setFiltersToUrl(this.filter);
                this.getOpportunitiesList();
            })
        }
    }
    filterEventEmitter() {
        const filterEl = document.querySelectorAll('[name="opportunityCategory"]');
        const addFilter = (filter: HTMLInputElement) => {
            const filterId = filter.getAttribute('data-filterId');
            if (this.filter.terms.some(i => i.filterId === filterId)) {
                const filterItem = this.filter.terms.find(i => i.filterId === filterId)
                if (!filterItem.terms.some(i => i.id === filter.id)) {
                    filterItem.terms.push({ id: filter.id, value: filter.value })
                }
            } else {
                this.filter.terms.push({ filterId: filterId, terms: [{ id: filter.id, value: filter.value }] })
            }
        }
        if (filterEl && filterEl.length) {

            this.resetFiltersEventListener(filterEl);

            filterEl.forEach(filter => {
                if ((filter as HTMLInputElement).checked) {
                    addFilter(filter as HTMLInputElement)
                }
                (filter as HTMLInputElement).addEventListener('change', (event) => {
                    const targetElement = event.target as HTMLInputElement;
                    this.filter.pageIndex = 1;
                    if (event.target['checked']) {
                        addFilter(targetElement)
                    } else {
                        const filterId = targetElement.getAttribute('data-filterId');
                        const filterItem = this.filter.terms.find(i => i.filterId === filterId);
                        if (filterItem) {
                            const index = filterItem.terms.findIndex(i => i.id === event.target['id'])
                            if (index !== null) {
                                filterItem.terms.splice(index, 1);
                            }
                            if (filterItem.terms.length === 0) {
                                const filterIndex = this.filter.terms.findIndex(i => i.filterId === filterId);
                                if (filterIndex !== null) {
                                    this.filter.terms.splice(filterIndex, 1);
                                }
                            }
                        }
                    }
                    this.setDataToLS()
                    this.setFiltersToUrl(this.filter);
                    this.getOpportunitiesList();
                })
            })
        }
    }
    /* -------- End Filter Logic ----------- */

    /* -------- Sort Logic ----------- */
    sortItemsEventListener() {
        const sortingEl: HTMLSelectElement = document.getElementById('opportunityItemSort') as HTMLSelectElement
        if (sortingEl) {
            this.filter.sort = sortingEl['value'];
            sortingEl.addEventListener('change', () => {
                this.filter.sort = sortingEl.value;
                this.setDataToLS();
                this.setFiltersToUrl(this.filter);
                this.getOpportunitiesList();
            })
        }
    }
    /* -------- Event Sort Logic ----------- */

    /* -------- Render Card List ----------- */
    renderCardList(cardList: OpportunityItemContent[]) {
        const createElement = (el: string, classes: string[], text?: string): HTMLElement => {
            const element = document.createElement(el !== ''? el : 'div');
            if (classes.length) {
                element.classList.add(...classes);
            }
            if (text) {
                element.innerHTML = text;
            }
            return element;
        }
      
        const cardItem = (info: OpportunityItemContent) => {
            const cardItemContainer: HTMLElement = createElement('li', ['directory-item']);
            const cardBlock: HTMLElement = createElement('div', ['opportunity-card', 'directory-list-item-content']); document.createElement('div');
            cardBlock.classList.add(`lead-${info.applyColor}`)
            const cardContent = createElement('div', ['card-content'])
            if (info.pageHeading) {
                const nameEl = createElement('div', ['card-row'])
                const webPage = createElement('p', ['bold'], info.eligibleRole)
                const title = createElement('h3', ['title'])
                const link = createElement('a', [], info.pageHeading);
                const linkHref = new URL(info.contentLink);
                linkHref['protocol'] = 'https';
                link.setAttribute('href', `${linkHref.toString()}`)

                title.append(link)
                nameEl.append(title)
                cardContent.append(webPage);
                cardContent.append(nameEl);
            }

            if (info.competencies) {
                const competencies = createElement('div', ['card-row'])
                competencies.append(createElement('p', ['bold'], info.competencies))
                cardContent.append(competencies);
            }

            if (info.shortDescription) {
                const shortDescription = createElement('div', ['card-row', 'shortDescription'])
                shortDescription.append(createElement('', [], info.shortDescription))
                cardContent.append(shortDescription);
            }

            const cardInfoBlock = createElement('div', ['card-info-block']);
            cardInfoBlock.classList.add(`lead-${info.applyColor}`)
            const cardContainer = createElement('div', ['card-info-container'])

            if (info.organization) {
                cardContainer.append(createElement('p', [], `<span class="bold">Organization:</span> ${info.organization}`));
            }
            if (info.duration) {
                cardContainer.append(createElement('p', [], `<span class="bold">Duration:</span> ${info.duration}`));
            }
            if (info.applicationWindow) {
                cardContainer.append(createElement('p', [], `<span class="bold">Application Window:</span> ${info.applicationWindow}`));
            }

            if (info.organization || info.duration || info.applicationWindow) {
                cardInfoBlock.append(cardContainer)
                cardContent.append(cardInfoBlock);
            }

            cardBlock.append(cardContent)
            cardItemContainer.append(cardBlock)
            return cardItemContainer;
        }
        const opportunitiesList = document.getElementById('opportunities-announcement-list')
        opportunitiesList.innerHTML = '';
        if (cardList.length) {
            opportunitiesList.classList.contains('showErrorMassage') && opportunitiesList.classList.remove('showErrorMassage');
            cardList.forEach(item => {
                opportunitiesList.append(cardItem(item))
            })
        } else {
            opportunitiesList.classList.add('showErrorMassage');
            opportunitiesList.append(createElement('div', ['opportunitiesMassage'], 'No opportunities found. Try adjusting your search filters, or reset your search to view all opportunities.'));
        }
    }


    /* -------- End Render Card List ----------- */
    /* -------- Search logic ----------- */

    searchEventListener() {
        // Get the search container element
        const opportunitySearch = document.getElementById('opportunitySearch');
        if (opportunitySearch) {
            // Get the search input element
            const opportunitySearchInput: HTMLInputElement = document.getElementById('opportunitySearchInput') as HTMLInputElement;
            // Get the clear button element
            const inputClearBtn = opportunitySearch.querySelector('.opportunity-term-clear');

            if (opportunitySearchInput) {
                // Add event listener to the search input for 'Enter' key press
                opportunitySearchInput.addEventListener('keydown', (e) => {
                    if (e.key === 'Enter') {
                        // Perform search when 'Enter' key is pressed
                        this.searchItems(opportunitySearchInput.value);
                    }
                });

                if (inputClearBtn) {
                    // Add event listener to the search input for input event
                    opportunitySearchInput.addEventListener('input', () => {
                        // Show or hide clear button based on search input value
                        opportunitySearchInput.value
                            ? inputClearBtn.classList.remove('visually-hidden')
                            : inputClearBtn.classList.add('visually-hidden');
                    });

                    // Add event listener to the clear button to clear search input
                    inputClearBtn.addEventListener('click', () => {
                        // Clear search and hide clear button
                        if (this.filter.searchText !== '') {
                            this.searchItems('');
                        }
                        opportunitySearchInput.value = '';
                        inputClearBtn.classList.add('visually-hidden');
                    });
                }
            }

            // Get the search button element
            const opportunitiesSearchButton = document.getElementById('opportunitiesSearchButton');
            if (opportunitiesSearchButton) {
                // Add event listener to the search button
                opportunitiesSearchButton.addEventListener('click', () => {
                    // Perform search when search button is clicked
                    this.searchItems(opportunitySearchInput.value);
                });
            }
        }
    }
    searchItems(text: string) {
        this.filter.searchText = text;
        this.filter.pageIndex = 1;
        this.setDataToLS();
        this.setFiltersToUrl(this.filter);
        this.getOpportunitiesList();
    }

    /* -------- End Search logic ----------- */

    /* -------- Pagination logic ----------- */
    generatePagination(paginationData: PagePagination) {
        // Select the pagination element
        const paginationList: HTMLElement = this.pageElement.querySelector('#opportunitespagination');
        // Clear the pagination element
        paginationList.innerHTML = '';
        if (paginationData.centeredPages.length) {
            paginationList.parentElement.classList.remove('visually-hidden');
            // Function to create a button element
            const createButton = (text: string, icon: string, classes: string[], id?: string, disabled?: boolean) => {
                const button = document.createElement('button');
                button.classList.add(...['un-button', 'hyperlink', ...classes]);
                button.innerHTML = `<svg class="svg-icon directory-pagination-arrow-icon" aria-hidden="true" focusable="false"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#${icon}"></use></svg><span class="directory-pagination-arrow-text">${text}</span>`;
                if (id) button.id = id;
                if (disabled) button.disabled = true;
                return button;
            };

            // Function to create a list item element
            const createListItem = (classes: string[], id?: string) => {
                const listItem = document.createElement('li');
                listItem.classList.add(...classes);
                if (id) listItem.id = id;
                return listItem;
            };

            // Create and append the previous button
            const prevBtn = createListItem(['directory-pagination-arrow', 'directory-pagination-arrow-left']);
            const prevButton = createButton('Previous', 'icon-left-arrow', ['h6-style', 'directory-pagination-button-prev'], null, paginationData.currentPageIndex === 1);
            prevBtn.append(prevButton);
            paginationList.append(prevBtn);

            // Create and append pagination items
            paginationData.centeredPages.forEach(item => {
                const listItemClasses = ['directory-pagination-list-item'];
                const spanContent = document.createElement('span');
                let itemButton;

                if (item.isActive || item.isEllipsis) {
                    // If active or ellipsis item, create a span
                    spanContent.textContent = item.isEllipsis ? '...' : `${item.pageNumber}`;
                    spanContent.classList.add('directory-pagination-text', 'bold');
                    itemButton = spanContent;
                } else {
                    // Otherwise, create a button
                    itemButton = createButton(`${item.pageNumber}`, '', ['directory-pagination-button', 'h6-style'], `opportunityPage-${item.pageNumber}`);
                }

                // Create list item and append button/span
                const listItem = createListItem(listItemClasses, 'pageLinks');
                if (item.isActive) listItem.classList.add('active');
                if (item.isEllipsis) listItem.classList.add('ellipsis');
                listItem.append(itemButton);
                paginationList.append(listItem);
            });

            // Create and append the next button
            const nextBtn = createListItem(['directory-pagination-arrow', 'directory-pagination-arrow-right']);
            const nextButton = createButton('Next', 'icon-right-arrow', ['h6-style', 'directory-pagination-button-next'], null, paginationData.currentPageIndex === paginationData.totalPages);
            nextBtn.append(nextButton);
            paginationList.append(nextBtn);

            // Attach event listeners to pagination elements
            this.paginationEventListener();
        } else {
            paginationList.parentElement.classList.add('visually-hidden');
            //show no events massege
        }

    }


    paginationEventListener() {
        // Get previous and next buttons
        const prevBtn: HTMLButtonElement = this.pageElement.querySelector('.directory-pagination-button-prev');
        const nextBtn: HTMLButtonElement = this.pageElement.querySelector('.directory-pagination-button-next');

        // Add event listeners to previous and next buttons
        prevBtn.addEventListener('click', e => {
            // Check if the previous button is not disabled
            if (!prevBtn.disabled) {
                // Decrease the page index and update the page
                this.setPageIndex(this.opportunitiesListData.pagePagination.currentPageIndex - 1);
            }
        });

        nextBtn.addEventListener('click', e => {
            // Check if the next button is not disabled
            if (!nextBtn.disabled) {
                // Increase the page index and update the page
                this.setPageIndex(this.opportunitiesListData.pagePagination.currentPageIndex + 1);
            }
        });

        // Get all pagination list items
        const listItems = this.pageElement.getElementsByClassName('directory-pagination-list-item');

        // Add event listeners to each list item
        if (listItems && listItems.length) {
            for (let i = 0; i < listItems.length; i++) {
                const itemBtn = listItems[i].querySelector('button.directory-pagination-button');
                if (itemBtn) {
                    const that = this;
                    // Add event listener to the button in the list item
                    itemBtn.addEventListener('click', function (e) {
                        // Extract the page number from the button's ID and update the page
                        const pageNumber = Number((this as HTMLElement).id.split('-')[1]);
                        that.setPageIndex(pageNumber);
                    });
                }
            }
        }
    }

    setPageIndex(pageNum: number) {
        this.filter.pageIndex = pageNum;
        this.setDataToLS();
        this.setFiltersToUrl(this.filter);
        this.getOpportunitiesList();
    }

    

    convertFilterTermsToString(terms: Array<FilterTerm>): string {
        let filtersRes = '';
        terms.forEach((filter, index) => {
            if (index > 0) filtersRes += '#'
            filtersRes += `${filter.filterId}:`;
            filtersRes += filter.terms.map(i => i.value.toUpperCase()).join('|')
        })
        return filtersRes;
    }
    convertStringToFilterTerms(str: string): Array<FilterTerm> {
        const terms: Array<FilterTerm> = []
        const filterData: string[] = str.includes('#') ? str.split('#') : [str];
        const filtersElements = document.querySelectorAll('input[name="opportunityCategory"]');
        const filtersList: Array<{ id: string; value: string }> = [];
        filtersElements.forEach(el => filtersList.push({ id: el.id, value: el['value'] }))
        if (filtersElements && filtersList.length) {
            filterData.forEach(term => {
                if (term.includes(':')) {
                    const splitTerm = term.split(':');
                    const termData: FilterTerm = { filterId: splitTerm[0], terms: [] }
                    const termValues = splitTerm[1].includes('|') ? splitTerm[1].split('|') : [splitTerm[1]]
                    termValues.forEach(val => {
                        const filterEl = filtersList.find(el => el.value.toUpperCase() == val.toUpperCase())
                        filterEl && termData.terms.push(filterEl)
                    })
                    if (termData.terms.length) {
                        terms.push(termData);
                    }
                }
            })
        }
        return terms;
    }

    updateItemCountData(data: OpportunityListResponce) {
        const element = document.getElementById('shownewscount')
        if (element) {
            const multiple = data.pagePagination.currentPageIndex * data.pageSize
            const start = multiple - data.pageSize + 1;
            const end = data.totalCount < multiple ? data.totalCount : multiple;
            const showingString = `${start} - ${end} OF ${data.totalCount}`
            element.textContent = `Showing ${data.totalCount === 0 ? 0 : showingString}`;
        }
    }

    /* -------- End Pagination logic ----------- */

    getOpportunitiesList() {

        // Get the host URL
        const host = window.location;
        // Define the API path
        const path = '/api/opportunities/getitems/';
        // Construct the complete URL
        const url = new URL(`${host.origin}${path}`);

        url.searchParams.set('pageId', this.pageId);

        url.searchParams.set('searchText', this.filter.searchText);

        url.searchParams.set('pageIndex', JSON.stringify(this.filter.pageIndex));

        this.filter.sort && url.searchParams.set('sort', this.filter.sort);

        if (this.filter.terms.length) {
            url.searchParams.set('terms', this.convertFilterTermsToString(this.filter.terms));
        }
        // Fetch data from the API
        fetch(url.toString())
            .then(response => response.json())
            .then((data: OpportunityListResponce) => {

                this.updateItemCountData(data);
                // Store fetched data
                this.opportunitiesListData = data;

                // Generate pagination based on fetched data
                this.generatePagination(data.pagePagination);

                // Update Filters Markers
                this.updateFilterMarkers(data.filtrations);

                this.renderCardList(data.contentItems);
            })
            .catch(error => {
                // Handle errors
                console.log('error', error);
            });
    }

}